import { ClickAwayListener, Popper } from "@mui/material";
import React, { useRef } from "react";
import CellContainer from "../cellContainer";
import { flexRender } from "@tanstack/react-table";
import "./TableCell.css";
import { BsCaretUpFill } from "react-icons/bs";
import DefaultFilterSet from "./defaultFilterSet";
import BroadFilters from "./broadFilters";

const RapCount = ({ data, cell, filters, totalCount }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isPopperHovered, setIsPopperHovered] = React.useState(false);
  const timerRef = useRef(null);

  // Handler for when mouse enters the cell
  const handleMouseEnter = (event) => {
    clearTimeout(timerRef.current);
    setAnchorEl(event.currentTarget);
  };

  // Handler for when mouse leaves the cell
  const handleMouseLeave = () => {
    // Don't close immediately if the popper is being hovered
    if (!isPopperHovered) {
      timerRef.current = setTimeout(() => {
        setAnchorEl(null);
      }, 100); // Small delay to allow mouse to move to popper
    }
  };

  // Handler for when mouse enters the popper
  const handlePopperMouseEnter = () => {
    clearTimeout(timerRef.current);
    setIsPopperHovered(true);
  };

  // Handler for when mouse leaves the popper
  const handlePopperMouseLeave = () => {
    setIsPopperHovered(false);
    timerRef.current = setTimeout(() => {
      setAnchorEl(null);
    }, 100);
  };

  // Close popper when clicking outside
  const handleClickAway = () => {
    setAnchorEl(null);
    setIsPopperHovered(false);
  };

  const open = Boolean(anchorEl);
  const rankDiff = cell.row.original["Rank Diff"];

  return (
    <>
      <Popper 
        open={open} 
        anchorEl={anchorEl} 
        placement="bottom" 
        style={{ zIndex: 999 }}
      >
        <div 
          onMouseEnter={handlePopperMouseEnter}
          onMouseLeave={handlePopperMouseLeave}
        >
          <ClickAwayListener onClickAway={handleClickAway}>
            {totalCount == null ? (
              <div className="gap-2 border border-[#cbcbcb] rounded-xl px-3 py-2 bg-white max-h-80 overflow-y-auto">
                <BroadFilters filters={filters} />
              </div>
            ) : (
              <div className="gap-2 border border-[#cbcbcb] rounded-xl px-3 py-2 bg-white max-h-80 overflow-y-auto">
                <div style={{ fontSize: "14px" }}>
                  Current filters show <strong>{cell.getValue() ? cell.getValue() : "-"}</strong> diamonds in the market
                </div>
                <hr />
                <DefaultFilterSet filters={filters} />
                <hr />
                <div style={{ fontSize: "14px" }}>
                  Filters can be broadened up to <strong>{totalCount}</strong> diamonds
                </div>
              </div>
            )}
          </ClickAwayListener>
        </div>
      </Popper>
      
      <td 
        key={cell.id} 
        className="h-10 items-center leaflet" 
        onMouseEnter={handleMouseEnter} 
        onMouseLeave={handleMouseLeave}
      >
        <CellContainer
          className="text-[0.685rem] font-medium mt-1 justify-end flex-col ml-2"
        >
          <div>{flexRender(cell.column.columnDef.cell, cell.getContext())}</div>
          {rankDiff ? (
            <div className="flex text-[0.55rem] items-center justify-between text-gray-500">
              <BsCaretUpFill
                height={"7px"}
                width={"7px"}
                className="hover:cursor-pointer"
              />
              ) +2
              <div className="w-3"></div>
            </div>
          ) : null}
        </CellContainer>
      </td>
    </>
  );
};

export default RapCount;